import React from 'react';
import useMycustomerForm from '../myCustomersComponents/useMycustomerForm';
const _ = require('lodash');
const GatewayInfo2 = (props) => {
    const { errors } = useMycustomerForm(props.infoData, props.index)
    const onValueChange = (e, index) => {
        let { value } = e.target
        props.infoData[index].PropValue = value
        props.onBlur(props.infoData, props.index)
    }
    props.onChange(errors)
    const renderError = (data, index) => {
        if (errors[index].PropName === data.PropName && errors[index].PropMsg) {
            return <div className="se-error-text">                
                {errors[index].PropMsg}</div>        }
    }
    const renderClass = (data, index) => {
        if (errors[index].PropName === data.PropName && errors[index].PropMsg) {
            return "se-form-control " + errors[index].PropClass
        } else {
            return "se-form-control"
        }
    }
    const isMobile = window.innerWidth <= 600;
    return <se-block display="grid">
        <div className="rows" align="">
            <div className="col-md-12 px-0">
                {_.map(props.infoData, (eachData, index) => {
                    return <div class="createBlockSize pb-3" style={{textAlign:isMobile ? 'left' : 'right', paddingTop: '10px'}}>
                        {eachData.PropName === "deviceType" ? null : 
                        <>
                        <label className="col-sm-3 col-lg-3 col-xl-3 se-label height20">{eachData.PropName}
                            {eachData.PropName === "Annual Income (INR)" ? null : <span class="se-mandatory">*</span>}
                        </label>
                        <div className="col-xl-4 col-lg-5 col-md-7 col-sm-8 px-0 text-left">
                            <input id = "mobile-gateway" type="text" style={{ width: isMobile ? '90%' : '100%', marginLeft:isMobile ?'1px' : '10px' }} className={renderClass(eachData, index)} placeholder="" autoComplete="off" name={eachData.PropName}
                                disabled={props.isDisabled} value={eachData.PropValue} onChange={(e) => onValueChange(e, index)} />
                            {renderError(eachData, index)}
                        </div>
                        </>
                         }
                    </div>
                })}
            </div>
        </div>
    </se-block>
}
export default GatewayInfo2